import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const AbstractLogoSquare = t0 => {
  const $ = _c(12);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[4] = size;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <rect fill="#00DE73" height={24} rx={0} width={24} />;
    t4 = <path d="m14.192 14.159 2.778 2.779-1.303 1.304-2.778-2.78a1.245 1.245 0 0 0-.89-.368c-.338 0-.652.13-.89.369l-2.778 2.779-1.303-1.304 2.778-2.78h4.386ZM10.524 5.76l1.016 3.795-2.193 3.8-3.796 1.018-.476-1.783 3.793-1.016c.325-.086.596-.294.764-.587.17-.29.213-.63.126-.955L8.743 6.237l1.781-.477Zm2.952 0 1.781.477-1.015 3.795c-.087.325-.043.665.126.955.168.293.439.5.764.587l3.793 1.016-.476 1.783-3.794-1.016-2.195-3.802 1.016-3.795Z" fill="#F7F9F3" />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== className || $[9] !== rest || $[10] !== t2) {
    t5 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}{t4}</svg>;
    $[8] = className;
    $[9] = rest;
    $[10] = t2;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export const AbstractLogoSquareMonochrome = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M0 0h24v24H0V0Zm14.192 14.159H9.806l-2.778 2.779 1.303 1.304 2.778-2.78c.238-.238.552-.368.89-.368.338 0 .652.13.89.369l2.778 2.779 1.303-1.304-2.778-2.78ZM10.524 5.76l-1.781.477 1.015 3.795c.087.325.043.665-.126.955-.168.293-.439.5-.764.587L5.075 12.59l.476 1.783 3.796-1.018 2.193-3.8-1.016-3.795Zm2.952 0L12.46 9.555l2.195 3.802 3.794 1.016.476-1.783-3.793-1.016a1.248 1.248 0 0 1-.764-.587 1.249 1.249 0 0 1-.126-.955l1.015-3.795-1.781-.477Z" fill={fillAttribute} fillRule="evenodd" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};